"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Occupation = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var Occupation = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Occupation, _super);
    function Occupation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷职业接口';
        _this.code = '101125';
        _this.desc = '现金贷职业接口';
        _this.requestParams = new cashLoanAuth_1.OccupationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Occupation;
}(service_1.BaseService));
exports.Occupation = Occupation;
//# sourceMappingURL=occupation.js.map